export default {
  REQUESTED_SIGNATURE: "RequestedSignature",
  SIGNED_BY_PARTICIPANT: "SignedByParticipant",
  SIGNED_BY_PI: "SignedByPI",
  COPY_EMAIL_TO_PARTICIPANT: "CopyEmailedToParticipant",
  UPLOADED: "Uploaded",
  Invalidated: "Invalidated",
  CANCELLED_BY_SITE: "CancelledBySite",
  REJECTED_BY_SITE: "RejectByPI",
  REJECTED_BY_PARTICIPANT: "RejectByParticipant",
  REQUESTED_SIGNATURE_FOR_CAREGIVER: "RequestedSignatureForCaregiver",
  SIGNED_BY_CAREGIVER: "SignedByCaregiver"
};
